module.exports = __webpack_public_path__ + "static/img/jz-logo.80f6500.png";